module.exports = __webpack_public_path__ + "static/media/gallery-lg-2.300e51b5.jpg";